import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ce6a94d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex-center gap-small" };
const _hoisted_2 = { id: "stats-numerical-title" };
const _hoisted_3 = _withScopeId(() => _createElementVNode("hr", { class: "full-width" }, null, -1));
const _hoisted_4 = {
    id: "stats-tuple-container",
    class: "full-width"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Tuple = _resolveComponent("Tuple");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Tuple, {
                value: _ctx.average,
                title: "Average",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.median,
                title: "Median",
                class: "grid-center"
            }, null, 8, ["value"]),
            _createVNode(_component_Tuple, {
                value: _ctx.deviation,
                title: "σ",
                class: "grid-center"
            }, null, 8, ["value"])
        ])
    ]));
}
